'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.RODIC = exports.NEPRIMY_ZASTUPCE = exports.PRIMY_ZASTUPCE = exports.SAM_K_SOBE = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-05-22T17:58:52Z                      #

// ##############################################################

/**
 * Typ vazby <ul> <li>"sám k sobě"</li> <li>"přímý zástupce" (jednatel)</li> <li>"nepřímý zástupce" (zástup PO (firma) nebo FO (manželka))</li> <li>"rodič"</li> <li>"opatrovník"</li> </ul>
 */

var SAM_K_SOBE = exports.SAM_K_SOBE = 'SAM_K_SOBE';

var PRIMY_ZASTUPCE = exports.PRIMY_ZASTUPCE = 'PRIMY_ZASTUPCE';

var NEPRIMY_ZASTUPCE = exports.NEPRIMY_ZASTUPCE = 'NEPRIMY_ZASTUPCE';

var RODIC = exports.RODIC = 'RODIC';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [SAM_K_SOBE, PRIMY_ZASTUPCE, NEPRIMY_ZASTUPCE, RODIC];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, SAM_K_SOBE, { caption: '' }), (0, _defineProperty3.default)(_params, PRIMY_ZASTUPCE, { caption: '' }), (0, _defineProperty3.default)(_params, NEPRIMY_ZASTUPCE, { caption: '' }), (0, _defineProperty3.default)(_params, RODIC, { caption: '' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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